import React from 'react'
import createCachedSelector from 're-reselect'
import { cn } from 'design-system'

import Tooltip from 'src/components/generics/tooltip'
import Callout, { types as calloutTypes } from 'src/components/generics/callout'

import InputLines from './InputLines'

const hasPunc = createCachedSelector(
  text => text,
  text => /[.!?;,]$/.test(text)
)(text => text)

const InputWrapper = ({
  children,
  className,
  Icon,
  label,
  labelSibling,
  labelId,
  inputId,
  errorMessage,
  errorMessageId,
  helpText,
  infoText,
  infoTextId,
  subText,
  subTextId,
  withLines = false,
  helpTextId,
  focused = false,
  labelProps,
  disabled = false,
  inlineLabel = false,
  wrapperTag: WrapperTag = 'div',
  labelTag: LabelTag = 'label'
}) => {
  const labelJSX = (
    <LabelTag
      className="yd-input-wrapper__label items-center gap-x-2"
      {...(labelId && { id: labelId })}
      {...(inputId && { htmlFor: inputId })}
      {...labelProps}>
      {Icon ? <Icon className="h-4 w-4 text-neutral-600" /> : null}
      {label}
    </LabelTag>
  )

  return children ? (
    <WrapperTag
      className={cn(
        'yd-input-wrapper',
        {
          'yd-input-wrapper--disabled': !!disabled,
          'yd-input-wrapper--label-inline': !!inlineLabel
        },
        className
      )}>
      {(label || helpText || errorMessage) && (
        <div className="yd-input-wrapper__header cf">
          {label && (
            <>
              {labelSibling ? (
                <>
                  {labelJSX}
                  <span className="ml-2">{labelSibling}</span>
                </>
              ) : (
                labelJSX
              )}
            </>
          )}

          {errorMessage && errorMessageId && (
            <div
              role="alert"
              id={errorMessageId}
              className="yd-input-wrapper__error yd-input-wrapper__error__message float-right">
              {hasPunc(errorMessage) ? (
                errorMessage
              ) : (
                <React.Fragment>
                  <span>{errorMessage}</span>
                </React.Fragment>
              )}
            </div>
          )}
          {helpText && helpTextId && (
            <div className="yd-input-wrapper__side-icon yd-input-wrapper__side-icon--left">
              <Tooltip id={helpTextId} label={helpText}>
                <div
                  tabIndex={0}
                  role="presentation"
                  className="yd-input-wrapper__help-button">
                  <span
                    aria-hidden="true"
                    className="yd-input-wrapper__help-button__icon f5">
                    ?
                  </span>
                </div>
              </Tooltip>
            </div>
          )}
        </div>
      )}
      <div className="yd-input-wrapper__input">
        {children}
        {withLines && !disabled && (
          <InputLines focused={focused} error={!!errorMessage} />
        )}
      </div>
      {infoText && (
        <div className="yd-input-wrapper__info-text-wrapper">
          <Callout id={infoTextId} type={calloutTypes.INFO}>
            {infoText}
          </Callout>
        </div>
      )}
      {subText && (
        <div
          id={subTextId}
          className="f6 px-2 py-1 font-normal text-neutral-600">
          {subText}
        </div>
      )}
    </WrapperTag>
  ) : null
}

export default InputWrapper
